import { ref } from "vue";
import api from "@/api/client";

// Global brand logo URLs (uploaded via admin) or null → component uses its
// bundled default. Module-level singleton, fetched once per app load
// (mirrors useEventConfig / useEventTitle).
interface BrandData {
  icon: string | null;
  stack: string | null;
  wide: string | null;
}

const brand = ref<BrandData>({ icon: null, stack: null, wide: null });
let loaded = false;

async function loadBrand() {
  if (loaded) return;
  loaded = true;
  try {
    const r = await api.get<BrandData>("/brand");
    brand.value = r.data;
  } catch {
    // keep nulls → components fall back to bundled defaults
  }
}

export function useBrand() {
  return { brand, loadBrand };
}
